import { render, staticRenderFns } from "./Prescription.vue?vue&type=template&id=0100fdbf&scoped=true"
import script from "./Prescription.vue?vue&type=script&lang=js"
export * from "./Prescription.vue?vue&type=script&lang=js"
import style0 from "./Prescription.vue?vue&type=style&index=0&id=0100fdbf&prod&scoped=true&lang=css"
import style1 from "./Prescription.vue?vue&type=style&index=1&id=0100fdbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0100fdbf",
  null
  
)

export default component.exports